import React, { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { toast } from "react-toastify";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import QRCodeDisplay from "../../../components/QRCodeDisplay"; // Import your QR code component
import { Link } from "react-router-dom";
import PayNow from "../FindTeacher/PayNow";

function OnlineTutoring() {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const student = JSON.parse(localStorage.getItem("edo-student"));
  const userId = student ? student.student.id : "";
  const [showThirdModal, setShowThirdModal] = useState(false);
  const [specificLink, setSpecificLink] = useState("");
  const [password, setPassword] = useState("");
  const [meetingNum, setMeetingNum] = useState("");

  const [showQRCodeModal, setShowQRCodeModal] = useState(false); // Modal visibility state
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewData, setReviewData] = useState({
    rating: 0,
    description: "",
    teacher_id: "",
    student_id: userId,
    teacher_request_id: "",
  });
  const handleOpenReviewModal = (item) => {
    setReviewData({
      rating: 0,
      description: "",
      teacher_id: item.teacher_id,
      student_id: userId,
      teacher_request_id: item.tbl_id,
    });
    setShowReviewModal(true);
  };
const submitReview = async () => {
  try {
    const response = await axios.post(`${apiKey}/api/edolutions/review/store`, reviewData, {
      headers: {
        Authorization: `Bearer ${student?.token}`,
      },
    });

    toast.success("Review submitted successfully!");
    setShowReviewModal(false);
  } catch (error) {
    if (error.response?.status === 409) {
      toast.warning("You have already submitted a review for this session.");
    } else {
      toast.error("Failed to submit review.");
    }
  }
};

  const handleShowQRCodeModal = (classId) => {
    setSelectedClassId(classId);
    setShowQRCodeModal(true); // Show modal
  };

  // Modal close function
  const handleCloseQRCodeModal = () => {
    setShowQRCodeModal(false); // Hide modal
    setSelectedClassId(null);
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${apiKey}/api/edolutions/student/read-notifications-all/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${student?.token}`,
            },
          }
        );
        setData(response.data.data);

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchData();
    }
  }, [userId, student?.token]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  const [sortOption, setSortOption] = useState("Newest");
  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  const sortedData = data.sort((a, b) => {
    if (sortOption === "Newest") {
      return new Date(b.created_at) - new Date(a.created_at);
    } else if (sortOption === "Oldest") {
      return new Date(a.created_at) - new Date(b.created_at);
    }
    return 0;
  });

  const filteredData = sortedData.filter(
    (item) =>
      item.teacher_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.class_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.subjects.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.type_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(Math.min(Math.max(1, pageNumber), totalPages));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleItemsPerPageChange = (event) => {
    const selectedItemsPerPage = parseInt(event.target.value, 10);
    setItemsPerPage(selectedItemsPerPage);
    setCurrentPage(1); // Reset to the first page when items per page changes
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const MeetingLink = (link) => {
    setSpecificLink(link);
    const zoom_link = link;
    const urlObj = new URL(zoom_link);
    const password = urlObj.searchParams.get("pwd");
    setPassword(password);
    // Extract meetingNumber
    const meetingNumber = zoom_link.match(/\/j\/(\d+)/)?.[1];
    setMeetingNum(meetingNumber);
    setShowThirdModal(true);
  };

  // Home Classes work here
  // Details of classes work shop here

  const [detail, setDetailModal] = useState(false);
  const [studentData, setStudentData] = useState(null);
  const [studentId, setStudentId] = useState(null);

  const studentDetails = async (id) => {
    setStudentId(id);
    // console.log(id);
    try {
      const response = await axios.get(
        `${apiKey}/api/edolutions/create-class-home/${id}`
      );

      const studentData = response.data.data;

      if (!studentData) {
        // Show toast error if no data found
        toast.error("Student class record not found", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      setStudentData(studentData);
      setDetailModal(true);
    } catch (error) {
      toast.error("Student Record Not Found Create class", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  // image work
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  // Time format
  function formatTime(time) {
    let [hours, minutes] = time.split(":");
    let period = "AM";

    hours = parseInt(hours, 10);

    if (hours >= 12) {
      period = "PM";
      if (hours > 12) {
        hours -= 12;
      }
    } else if (hours === 0) {
      hours = 12;
    }

    return `${hours}:${minutes} ${period}`;
  }

  const [expandedRow, setExpandedRow] = useState(null);

  const handleToggleDetails = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  return (
    <>
      <div className="flex items-center xl:p-5 sm:p-0 justify-center">
        <div className="w-full border rounded-3xl shadow-xl p-5">
          <div className="mt-2">
            <div className="flex flex-col md:flex-row items-center justify-between p-2">
              <div className="flex justify-between">
                <p className="text-[22px] font-bold">My Tutoring </p>
              </div>
              <div className="flex flex-col gap-3 md:flex-row md:items-center">
                <div className="relative border shadow-md rounded-md flex items-center px-5 py-2">
                  <FiSearch className="h-5 w-5 absolute text-[#5963F5]" />
                  <input
                    type="text"
                    className="outline-none pl-8"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
                <div className="relative ml-2">
                  <select
                    className="border shadow-md rounded-md cursor-pointer px-5 py-2 outline-none pl-2 pr-8 text-sm"
                    value={sortOption}
                    onChange={handleSortChange}
                  >
                    <option value="Newest">Sort By: Newest</option>
                    <option value="Oldest">Sort By: Oldest</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <div className="mt-5">
                <div className="overflow-x-auto">
                  {/* Table for large screens */}
                  <table className="hidden sm:table min-w-full w-full text-sm text-left text-gray-500 border-b table-auto">
                    <thead className="text-xs sm:text-sm text-[#B5B7C0] font-medium border-b">
                      <tr className="border-b">
                        <th className="py-3 px-1">Teacher Name</th>
                        <th className="py-3 px-1">Class</th>
                        <th className="py-3 px-1">Subject</th>
                        <th className="py-3 px-1">Type</th>
                        <th className="py-3 px-1">Classes/Meeting</th>
                        <th className="py-3 px-1">QR Code</th>
                        <th className="py-3 px-1">Details</th>
                      </tr>
                    </thead>
                    <tbody className="text-black text-xs sm:text-sm font-medium">
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="py-5 px-1 text-center">
                            <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
                              <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
                              <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">
                                Edolution...
                              </p>
                            </div>
                          </td>
                        </tr>
                      ) : paginatedData.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="py-5 px-1 text-center">
                            <p className="text-gray-500">
                              No Home Tutoring Available
                            </p>
                          </td>
                        </tr>
                      ) : (
                        paginatedData.map((item, index) => (
                          <React.Fragment key={index}>
                            <tr className="border-b">
                              <td className="py-5 px-1">{item.teacher_name}</td>
                              <td className="py-5 px-1">{item.class_name}</td>
                              <td className="py-5 px-1">{item.subjects}</td>
                              <td className="py-5 px-1 capitalize">
                                {item.type_name}
                              </td>
                              <td
                                className={`cursor-pointer ${item.type_name === "online" ? "" : "hidden"
                                  }`}
                                onClick={() =>
                                  item.type_name === "online" &&
                                  MeetingLink(item.join_url)
                                }
                              >
                                <p className="bg-slate-200 text-center w-fit px-5 rounded-lg py-1">
                                  Link
                                </p>
                              </td>
                              <td
                                className={`cursor-pointer ${item.type_name === "home" ? "" : "hidden"
                                  }`}
                                onClick={() => studentDetails(item.tbl_id)}
                              >
                                <p className="bg-slate-200 text-center w-fit px-5 rounded-lg py-1">
                                  View
                                </p>
                              </td>
                              <td>
                                {item.type_name === "home" ? (
                                  item.Fee === "unpaid" ? (
                                    // <Link
                                    //   to={`/student/pay-fees/${item.tbl_id}`}
                                    //   className="bg-[#f95050] text-sm text-white px-4 py-2 rounded-md"
                                    // >
                                    //   Pay Fees
                                    // </Link>
                                    <PayNow
                                      classId={item.tbl_id}
                                      stdId={item.student_id}
                                      item={item.subjects}
                                      amount={10}
                                      payeeName={item.student_name}
                                      email={item.email}
                                      msisdn={item.phone}
                                      description="Tuition Fee"
                                    />
                                  ) : (
                                    <button
                                      className="bg-[#72dad0] text-sm text-white px-4 py-2 rounded-md"
                                      onClick={() =>
                                        handleShowQRCodeModal(item.tbl_id)
                                      }
                                    >
                                      Show QR
                                    </button>
                                  )
                                ) : item.type_name === "online" &&
                                  item.Fee === "unpaid" ? (
                                  <PayNow
                                    classId={item.tbl_id}
                                    stdId={item.student_id}
                                    item={item.subjects}
                                    amount={10}
                                    payeeName={item.student_name}
                                    email={item.email}
                                    msisdn={item.phone}
                                    description="Tuition Fee"
                                  />
                                ) : (
                                  <span>N/A</span>
                                )}
                              </td>

                              <td className="py-5 px-1">
                                <button
                                  className="text-blue-500 underline"
                                  onClick={() => handleToggleDetails(index)}
                                >
                                  {expandedRow === index ? (
                                    <AiOutlineEyeInvisible className="text-lg text-[#72dad0]" />
                                  ) : (
                                    <AiOutlineEye className="text-lg text-[#72dad0]" />
                                  )}
                                </button>
                              </td>
                            </tr>
                            {expandedRow === index && (
                              <tr>
                                <td colSpan="7">
                                  <div className="overflow-x-auto">
                                    <table className="min-w-full w-full text-sm text-left text-gray-500 rounded-lg shadow-lg table-auto">
                                      <thead className="text-sm text-white bg-[#72dad0] font-medium">
                                        <tr>
                                          <th className="py-3 px-1">Day</th>
                                          <th className="py-3 px-1">Timing</th>
                                          <th className="py-3 px-1">
                                            Duration
                                          </th>
                                          <th className="py-3 px-1">Payment</th>
                                          <th className="py-3 px-1">Status</th>
                                          <th className="py-3 px-1">Reviews</th>
                                        </tr>
                                      </thead>
                                      <tbody className="text-black text-xs sm:text-sm font-medium">
                                        <tr>
                                          <td className="py-5 px-1 capitalize">
                                            {item.day_name || "Not Defined"}
                                          </td>
                                          <td className="py-5 px-1">
                                            {item.start_time && item.end_time
                                              ? `${formatTime(
                                                item.start_time
                                              )} to ${formatTime(
                                                item.end_time
                                              )}`
                                              : item.timeslot_id}
                                          </td>
                                          <td className="py-5 px-1">
                                            {item.days} {item.duration}
                                          </td>
                                          <td className="py-5 px-1">
                                            Rs.{item.payment}
                                          </td>
                                          <td className="py-5 px-1">
                                            {item.Fee === "unpaid" ? (
                                              <Link
                                                to={`/student/pay-fees/${item.tbl_id}`}
                                                className="bg-[#72dad0] text-sm text-white px-4 py-2 rounded-md"
                                              >
                                                Pay Fees
                                              </Link>
                                            ) : (
                                              <span>Paid</span>
                                            )}
                                          </td>
                                          <td>
                                            {item.Fee === "paid" && (
                                              <button
                                                className="bg-[#4FD1C5] text-white text-sm px-3 py-1 rounded-md"
                                                onClick={() => handleOpenReviewModal(item)}
                                              >
                                                Give Review
                                              </button>
                                            )}
                                          </td>

                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      )}
                    </tbody>
                  </table>

                  {/* Cards for mobile screens */}
                  <div className="sm:hidden">
                    {loading ? (
                      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
                        <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
                        <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">
                          Edolution...
                        </p>
                      </div>
                    ) : paginatedData.length === 0 ? (
                      <p className="text-gray-500 text-center py-5">
                        No Home Tutoring Available
                      </p>
                    ) : (
                      paginatedData.map((item, index) => (
                        <div
                          key={index}
                          className="border-b p-3 flex flex-col bg-white shadow-sm rounded-lg mb-4"
                        >
                          <div className="flex justify-between text-sm sm:text-base">
                            <p className="font-semibold">Teacher Name:</p>
                            <p>{item.teacher_name}</p>
                          </div>

                          <div className="flex justify-between text-sm sm:text-base">
                            <p className="font-semibold">Class:</p>
                            <p>{item.class_name}</p>
                          </div>

                          <div className="flex justify-between text-sm sm:text-base">
                            <p className="font-semibold">Subject:</p>
                            <p>{item.subjects}</p>
                          </div>

                          <div className="flex justify-between text-sm sm:text-base">
                            <p className="font-semibold">Type:</p>
                            <p className="capitalize">{item.type_name}</p>
                          </div>

                          <div
                            className={`flex justify-between text-sm sm:text-base ${item.type_name === "online" ? "" : "hidden"
                              }`}
                          >
                            <p className="font-semibold">Meeting Link:</p>
                            <button
                              onClick={() =>
                                item.type_name === "online" &&
                                MeetingLink(item.join_url)
                              }
                              className="text-blue-500"
                            >
                              Open
                            </button>
                          </div>

                          <div
                            className={`flex justify-between text-sm sm:text-base ${item.type_name === "home" ? "" : "hidden"
                              }`}
                          >
                            <p className="font-semibold">Details:</p>
                            <button
                              onClick={() => studentDetails(item.tbl_id)}
                              className="text-blue-500"
                            >
                              View
                            </button>
                          </div>

                          <div className="flex justify-between text-sm sm:text-base">
                            <p className="font-semibold">QR Code:</p>
                            <button
                              className="bg-[#72dad0] text-white px-3 py-1 rounded-md text-xs sm:text-sm"
                              onClick={() => handleShowQRCodeModal(item.tbl_id)}
                            >
                              Show QR
                            </button>
                          </div>

                          <button
                            className="text-blue-500 underline mt-4 text-sm sm:text-base"
                            onClick={() => handleToggleDetails(index)}
                          >
                            {expandedRow === index ? (
                              <AiOutlineEyeInvisible className="text-lg text-[#72dad0]" />
                            ) : (
                              <AiOutlineEye className="text-lg text-[#72dad0]" />
                            )}
                          </button>

                          {expandedRow === index && (
                            <div className="mt-4">
                              <p className="font-semibold">Details:</p>
                              <p className="text-sm sm:text-base">
                                Day: {item.day_name || "Not Defined"} | Timing:{" "}
                                {item.start_time && item.end_time
                                  ? `${formatTime(
                                    item.start_time
                                  )} to ${formatTime(item.end_time)}`
                                  : item.timeslot_id}{" "}
                                | Duration: {item.days} {item.duration} |
                                Payment: Rs.
                                {item.payment}
                              </p>
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-5 justify-between items-center w-full text-sm mt-4 pb-4 px-2">
              <div className="flex items-center gap-x-2 text-gray-400">
                <span>
                  <select
                    className="text-sm border-none text-black bg-[#F5F5F5] rounded-lg"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    {[10, 20, 30, 40, 50, 100].map((perPage) => (
                      <option key={perPage} value={perPage}>
                        {perPage}
                      </option>
                    ))}
                  </select>
                </span>
                <span>Showing Data</span>
                <span>
                  {startIndex + 1}-{endIndex} of {totalItems} Entries
                </span>
              </div>
              <div className="flex items-center gap-x-2 text-gray-400">
                <button
                  className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
                <div className="flex items-center gap-x-2 text-gray-400">
                  {[...Array(Math.min(5, totalPages || 1))].map((_, index) => {
                    const pageNumber = Math.max(currentPage - 2 + index, 1);
                    const isActive = pageNumber === currentPage;
                    return (
                      <button
                        key={pageNumber}
                        className={`text-base rounded-lg px-3 py-1 ${isActive
                          ? "text-white bg-[#4FD1C5]"
                          : "text-black bg-[#F5F5F5]"
                          }`}
                        onClick={() => handlePageChange(pageNumber)}
                        disabled={pageNumber < 1 || pageNumber > totalPages}
                      >
                        {pageNumber}
                      </button>
                    );
                  })}
                  <span>of {totalPages || 1} pages</span>
                </div>
                <button
                  className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showQRCodeModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-5 rounded-md shadow-lg">
            {/* <h2 className="text-lg font-semibold mb-4">QR Code for Class</h2> */}
            <QRCodeDisplay classId={selectedClassId} /> {/* Display QR Code */}
            <div className="mt-4 flex justify-end">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-md"
                onClick={handleCloseQRCodeModal} // Close modal on button click
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 3rd Modal */}
      {showThirdModal && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
              <div className="flex justify-between items-center p-4 border-b border-gray-200">
                <h2 className="text-xl font-semibold">Specific Link</h2>
                <button
                  className="text-2xl text-gray-600 hover:text-gray-800"
                  onClick={() => setShowThirdModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="p-6">
                <p className="mb-4 text-sm text-gray-700">
                  Here is the specific link to join meeting:
                </p>
                <div className="mb-4 p-4 bg-gray-100 border rounded-md">
                  <a
                    href={specificLink}
                    className="text-blue-600 hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {specificLink}
                  </a>
                </div>
                <button
                  className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
                  onClick={() => {
                    window.location.href = `/student/ZoomMeetingPageStd?meetingUrl=${encodeURIComponent(
                      specificLink
                    )}&meetingNumber=${meetingNum}&password=${password}`;
                  }}
                >
                  Join Meeting
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Details model homme Modal */}
      <div>
        {/* Image Modal */}
        {selectedImage && (
          <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-75">
            <div className="relative">
              <img
                src={selectedImage}
                alt="Selected Snap"
                className="max-w-full max-h-screen object-contain"
              />
              <button
                className="absolute top-0 right-0 m-4 text-white text-3xl"
                onClick={closeImageModal}
              >
                ×
              </button>
            </div>
          </div>
        )}
      </div>
      <div>
        {detail ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-[90%] sm:w-11/12 lg:w-9/12 xl:w-1/2 mx-auto">
                {/* Content */}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel max-h-[90vh]">
                  {/* Header */}
                  <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h3 className="text-lg sm:text-xl font-semibold">
                      Student Classes Details
                    </h3>
                    <button
                      className="text-[#000] bg-white text-2xl sm:text-3xl px-1"
                      onClick={() => setDetailModal(false)}
                    >
                      ×
                    </button>
                  </div>

                  {/* Body */}
                  <div className="relative p-4">
                    {/* Table Container for scrolling on small screens */}
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead>
                          <tr>
                            <th className="px-2 sm:px-6 py-3 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider">
                              Snap
                            </th>
                            <th className="px-2 sm:px-6 py-3 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider">
                              Location
                            </th>
                            <th className="px-2 sm:px-6 py-3 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider">
                              Start Time
                            </th>
                            <th className="px-2 sm:px-6 py-3 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider">
                              End Time
                            </th>
                            <th className="px-2 sm:px-6 py-3 text-left text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider">
                              Total Time
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {studentData && studentData.length > 0 ? (
                            studentData.map((student) => {
                              const startTime = new Date(student.start_time);
                              const endTime = new Date(student.end_time);
                              const totalTime = Math.max(
                                0,
                                endTime - startTime
                              ); // Total time in milliseconds
                              const totalHours = Math.floor(
                                totalTime / 3600000
                              ); // Convert milliseconds to hours
                              const totalMinutes = Math.floor(
                                (totalTime % 3600000) / 60000
                              ); // Convert remaining milliseconds to minutes

                              return (
                                <tr key={student.id}>
                                  <td className="px-2 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    <img
                                      src={`${apiKey}/homeSnap/${student.snap}`}
                                      alt=""
                                      className="inline-block mr-2 h-12 w-12 object-cover cursor-pointer"
                                      onClick={() =>
                                        handleImageClick(
                                          `${apiKey}/homeSnap/${student.snap}`
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="px-2 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    {student.location}
                                  </td>
                                  <td className="px-2 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    {student.start_time}
                                  </td>
                                  <td className="px-2 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    {student.end_time}
                                  </td>
                                  <td className="px-2 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {totalHours}h {totalMinutes}m
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="px-6 py-4 text-sm text-gray-500 text-center"
                              >
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
  {showReviewModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded-md shadow-lg w-full max-w-md">
      <h2 className="text-xl font-bold mb-4">Submit Review</h2>

      {/* Rating */}
      <div className="flex space-x-2 mb-4">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            onClick={() => setReviewData({ ...reviewData, rating: star })}
            className={`text-2xl cursor-pointer ${star <= reviewData.rating ? "text-yellow-400" : "text-gray-300"
              }`}
          >
            ★
          </span>
        ))}
      </div>

      {/* Description */}
      <textarea
        className="w-full border rounded p-2"
        rows="3"
        placeholder="Write your review..."
        value={reviewData.description}
        onChange={(e) =>
          setReviewData({ ...reviewData, description: e.target.value })
        }
      ></textarea>

      {/* Actions */}
      <div className="flex justify-end mt-4 gap-2">
        <button
          className="bg-gray-400 text-white px-4 py-2 rounded"
          onClick={() => setShowReviewModal(false)}
        >
          Cancel
        </button>
        <button
          className="bg-[#4FD1C5] text-white px-4 py-2 rounded"
          onClick={submitReview}
        >
          Submit
        </button>
      </div>
    </div>
  </div>
)}

        {/* Image Modal */}
        {selectedImage && (
          <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-75">
            <div className="relative">
              <img
                src={selectedImage}
                alt="Selected Snap"
                className="max-w-full max-h-screen object-contain"
              />
              <button
                className="absolute top-0 right-0 m-4 text-white text-2xl sm:text-3xl"
                onClick={closeImageModal}
              >
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default OnlineTutoring;
